import router from '@/router';
import { Message,Loading } from 'element-ui'
import { userControl,xtsz } from '@/axios';
import { navs } from '@/router/nav.js'
import {
	zzshRoutes
} from '@/router/permission.js'
let loading

export default{
	namespace: true,
	state:{
		userinfo:{},
		logo:"",
		token:"",
		leftNav:[],
		leftName:"",
		leftIcon:"",
		leftSelectPath:"",
		topSelect:""
	},
	mutations:{
		// 设置用户数据
		setUserInfo(state,data){
			console.log(navs);
			state.userinfo = data
			state.token = data.token
			state.navList = navs
			state.topSelect = '/zbgk';
			router.push('/zbgk')
		},
		// 清除用户信息
		clearUserInfo(state,data){
			for(let i in state){
				state[i] = ""
			}
			// location.reload()
			router.push('/login')
		},
		// 左侧导航
		setLeftNav(state,data){
			state.leftNav = data;
		},
		// 左侧选中图标和名称
		setTopInfo(state,data){
			state.leftName = data.name;
			state.leftIcon = data.icon;
		},
		setLeftSelect(state,data){
			state.leftSelectPath = data;
		},
		// 设置logo
		setLogo(state,data){
			state.logo = data;
		},
		// 顶部选中
		setTopSelect(state,data){
			state.topSelect = data;
		}
	},
	actions:{
		LOGIN({commit,dispatch},data){
			// 登录
			userControl.login(data).then(res => {
				if(res.code == 0){
					console.log(res);
					commit('setUserInfo',res.data)
					dispatch("GET_LOGO",{
						dwid:res.data.dwid
					})
				}else{
					Message.error(res.msg);
				}
			})
		},
		// 获取logo
		GET_LOGO({commit},data){
			xtsz.selectLogo(data).then(res => {
				if(res.code == 200){
					commit('setLogo',res.data.logo)
				}
			})
		},
		// 获取logo
		SET_LOGO({commit,dispatch},data){
			xtsz.setLogo(data).then(res => {
				if(res.code == 200){
					dispatch("GET_LOGO",{
						dwid:data.dwid
					})
				}
			})
		},
	}
}